import React from 'react';
import { Avatar, IconButton, ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { firmSummaryUrl } from 'common/config/urls';
import { PushPin } from 'icons';
import { getInitials } from 'utilities';
import { FirmOptionProps } from './FirmOption.props';
import { firmOptionClasses, StyledLink, StyleOutlinedPushPin } from './FirmOption.styles';

const FirmOption = ({ 
  slug, 
  name, 
  id, 
  isPinnable = false, 
  isPinned = false, 
  updatePinStatus 
}: FirmOptionProps) => (
  <StyledLink to={firmSummaryUrl(slug)} data-testid={slug}>
    <ListItem component="button">
      <ListItemIcon>
        <Avatar className={firmOptionClasses.avatar}>{getInitials({ name })}</Avatar>
      </ListItemIcon>
      <ListItemText primary={name} />
      {isPinnable && (
        <Tooltip title={isPinned ? 'Unpin' : 'Pin'}>
          <IconButton
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              e.preventDefault();
              if (updatePinStatus && id) {
                updatePinStatus(id, name, isPinned);
              }
            }}
            size="small"
            aria-label="pin"
            style={{ marginLeft: '8px' }}
          >
            {isPinned ? (
              <PushPin fontSize="small" htmlColor="rgba(0, 0, 0, 0.6)"/>
            ) : (
              <StyleOutlinedPushPin fontSize="small" htmlColor="rgba(0, 0, 0, 0.6)" />
            )}
          </IconButton>
        </Tooltip>
      )}
    </ListItem>
  </StyledLink>
);

export default FirmOption;
